import React, { memo } from 'react';
import { UTLabel, WithLoading } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';
import { emailField } from 'constants/fields';
import UTForm from 'app/components/UTForm';

import styles from './styles.module.scss';

const fields = [{ ...emailField, title: message('Configuration:changeEmailPlaceholder') }];
const SendEmail = () => (
  <React.Fragment>
    <UTLabel className={styles.description}>{message('Configuration:changeEmailModalContent')}</UTLabel>
    <UTForm fields={fields} />
  </React.Fragment>
);

export default WithLoading(props => props.loading)(memo(SendEmail));
